import { render } from "./NotificationsComp.vue?vue&type=template&id=37c26754&scoped=true"
import script from "./NotificationsComp.vue?vue&type=script&lang=js"
export * from "./NotificationsComp.vue?vue&type=script&lang=js"

import "./NotificationsComp.vue?vue&type=style&index=0&id=37c26754&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c26754"]])

export default __exports__